export default "<p>&lt;!-- @api: OtCard.vue/OtCardAPI.md --&gt;</p>\n<h1>Card 卡片</h1>\n<p>将信息聚合在卡片容器中展示。</p>\n"